import React from 'react'
import toast from 'react-hot-toast';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';

function Pagination({userLength,userLimit,userPage,onBack,onNext}) {
  return (
   <>
    <div className="h-[10vh] w-full flex justify-start items-center gap-2">
              <button
                disabled={
                  userPage <= 1 || Math.ceil(userLength / userLimit)==1  ? true : false
                }
                className={`h-[50px] w-[50px] rounded-lg flex justify-center items-center ${
                  userPage <= 1 ||  Math.ceil(userLength / userLimit)==1
                    ? "text-gray-400"
                    : "text-black cursor-pointer"
                } text-[20px]`}
                onClick={() => {
                  if (userPage > 1) {
                    onBack(userPage - 1);
                    // userPageNext();
                  } else {
                    toast.error("Underflow");
                  }
                }}
              >
                <BsChevronLeft />
              </button>
              <label> Pages:</label>
              {
                <label className="flex justify-center items-center h-[50px] w-[50px] text-black rounded-lg">
                  {userPage}
                </label>
              }
              <label>out of</label>
              {
                <label className="flex justify-center items-center h-[50px] w-[50px] text-black rounded-lg">
                  {Math.ceil(userLength / userLimit)}
                </label>
              }
              <button
                disabled={
                  userPage > Math.ceil(userLength / userLimit) - 1 ? true : false
                }
                className={`h-[50px] w-[50px] rounded-lg flex justify-center items-center ${
                  userPage > Math.ceil(userLength / userLimit) - 1
                    ? "text-gray-400"
                    : "text-black cursor-pointer"
                } text-[20px]`}
                onClick={() => {
                  if (userPage <= Math.ceil(userLength / userLimit) - 1) {
                    onNext(userPage + 1);
                    // userPageNext()
                  } else {
                    toast.error("overflow");
                  }
                }}
              >
                <BsChevronRight />
              </button>
            </div>
   </>
  )
}

export default Pagination